import React from "react";
import { NavLink } from "react-router-dom";
import Logo from "../../Components/Common/Logo";
import HomeData from "./HomeData/HomeData";
const HomeLeft = () => {
  return (
    <div className="relative min-h-screen bg-gray-100 w-full">
      <div className="absolute top-0 end-0 p-6">
        <Logo />
      </div>

      <div className="flex items-center justify-center w-full h-screen">
        <div className="w-full max-w-xl space-y-2">
          <h1 className="text-3xl font-bold ">Welcome to the Office Flow!</h1>
          <i className="text-sm">Your complete workplace management platform.</i>
          {HomeData?.map(({ path, imgSrc, altText, title, description }) => (
            <NavLink
              key={path}
              to={path}
              className="bg-white flex justify-between items-center shadow-md rounded-lg p-4 hover:bg-gray-200 transition hover:cursor-pointer duration-300"
            >
              <div className="flex gap-2">
                <div className="h-16 w-16">
                  <img src={imgSrc} alt={altText} />
                </div>
                <div className="flex items-center">
                  <div>
                    <h2 className="text-xl font-semibold">{title}</h2>
                    <p className="text-gray-600">{description}</p>
                  </div>
                </div>
              </div>
              <span className="text-gray-600 text-2xl">&rarr;</span>
            </NavLink>
          ))}

          <p className="text-gray-600 text-sm mt-4">
            By signing in, you agree to our{" "}
            <NavLink
              to="/privacy-policy"
              className="text-blue-600 underline hover:text-blue-800 transition-colors duration-200"
            >
              Privacy Policy
            </NavLink>
            ,{" "}
            <NavLink
              to="/terms-and-conditions"
              className="text-blue-600 underline hover:text-blue-800 transition-colors duration-200"
            >
              Terms of Use
            </NavLink>{" "}
            and{" "}
            <NavLink
              to="/cookie-policy"
              className="text-blue-600 underline hover:text-blue-800 transition-colors duration-200"
            >
              Cookie Policy
            </NavLink>
            .
          </p>
          <p className="text-gray-600 text-sm">
            ©The Office Flow. All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HomeLeft;
